import Controller from '@ember/controller';
import { action, set } from '@ember/object';
import { inject as service } from '@ember/service';
import { ApplicationFlowUpdate } from '@square/dashboard-protos/models/squareup/sfs/external/models/application_flow_update';
import { tracked } from '@glimmer/tracking';

export default class ConfirmIdentityController extends Controller {
  @service currentApplicationFlow;
  @service addressValidation;
  @service router;
  @tracked isLoading = false;

  @action
  async continue() {
    try {
      this.isLoading = true;

      let hasSignificantChanges = false;

      if (!this.addressValidation.didShowIndividualValidation) {
        await this.addressValidation.validateAndStandardizeIndividual(
          this.currentApplicationFlow.individual.address
        );

        if (!this.addressValidation.individualFailedValidation) {
          hasSignificantChanges = this.addressValidation.hasSignificantChanges(
            this.addressValidation.individualStandardizationChanges
          );
          await this.updateAddress();
        }
      }

      if (
        this.addressValidation.individualFailedValidation &&
        !this.addressValidation.didShowIndividualValidation
      ) {
        set(this, 'addressValidation.didShowIndividualValidation', true);
        this.router.transitionTo('signup.confirm-identity.invalid-address');
      } else if (hasSignificantChanges) {
        set(this, 'addressValidation.didShowIndividualValidation', true);
        this.router.transitionTo('signup.confirm-identity.address');
      } else {
        this.router.transitionTo('signup.confirm-business');
      }
    } catch (error) {
      this.send('handleRpcError', error);
    } finally {
      this.isLoading = false;
    }
  }

  async updateAddress() {
    const individualUpdate =
      new ApplicationFlowUpdate.IndividualUpdate.Builder()
        .id(this.currentApplicationFlow.individual?.id)
        .address(this.addressValidation.individualStandardizedAddress)
        .isManager(this.currentApplicationFlow.individual?.isManager)
        .hasSignificantOwnership(
          this.currentApplicationFlow.individual?.hasSignificantOwnership
        )
        .build();

    const applicationFlowUpdate = new ApplicationFlowUpdate.Builder()
      .id(this.currentApplicationFlow.id)
      .individual(individualUpdate)
      .build();

    await this.currentApplicationFlow.update(applicationFlowUpdate);
  }
}
